import React from 'react';
import { Images } from '../../constants';
import FeatureCard from '../Card/FeatureCard';
import { useSelector } from 'react-redux';

const Feature = () => {

  const theme = useSelector((state)=> state.general.lightMode)


  return (
    <div className={` ${ theme ? 'bg-slate-100' : 'bg-slate-800' } flex-col flex justify-center items-center `}>
      <h1 className={`  ${ theme ? 'text-black' : 'text-white'} py-4 text-center text-2xl md:text-3xl lg:text-4xl font-bold`}>Essential <span className='text-blue-500  animate-typing overflow-hidden whitespace-nowrap'>Feature</span></h1>
      <h2 className={` ${ theme ? 'text-black' : 'text-white'} text-lg md:text-xl lg:text-2xl text-center font-bold`}>This amazing Webflow template gives you all the essential features.</h2>
      <div className='flex  md:flex-row p-5 lg:pt-16  lg:gap-10 w-full md:w-3/4 justify-between items-center'>

      <FeatureCard title={"Responsive design"} image={Images.FEATURE1} url={"#"} />
      <FeatureCard title={"Interactions"} image={Images.FEATURE2} url={"#"} />
      <FeatureCard title={"Cross-Browser"} image={Images.FEATURE3} url={"#"} />


      </div>
    </div>
  );
};

export default Feature;
